// extracted by mini-css-extract-plugin
export var alignmentCenter = "typography--alignment-center--133f5";
export var alignmentLeft = "typography--alignment-left--de7b2";
export var alignmentRight = "typography--alignment-right--6af84";
export var emphasisMedium = "typography--emphasis-medium--56f43";
export var emphasisNormal = "typography--emphasis-normal--98b5b";
export var emphasisStrong = "typography--emphasis-strong--90a97";
export var lineHeightSingleLine = "typography--line-height-single-line--9d5be";
export var sizeLarge = "typography--size-large--93f3c";
export var sizeMedium = "typography--size-medium--21292";
export var sizeSmall = "typography--size-small--7fd79";
export var sizeXLarge = "typography--size-x-large--1372e";
export var sizeXSmall = "typography--size-x-small--03542";
export var sizeXxLarge = "typography--size-xx-large--9652e";
export var sizeXxxLarge = "typography--size-xxx-large--f85c5";
export var toneDisabled = "typography--tone-disabled--892a2";
export var toneNegative = "typography--tone-negative--59b93";
export var toneNeutralDark = "typography--tone-neutral-dark--ed3e2";
export var toneNeutralLight = "typography--tone-neutral-light--f100b";
export var tonePositive = "typography--tone-positive--3c303";
export var toneSubtle = "typography--tone-subtle--e4128";
export var toneWarning = "typography--tone-warning--77fa7";